import { render, staticRenderFns } from "./Beamer.vue?vue&type=template&id=4a3da2a9"
import script from "./Beamer.vue?vue&type=script&lang=ts"
export * from "./Beamer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports